import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { fetchUser } from './actions/index';
import './index.css';
import App from './App';
import Errors from './App/common/Errors';
import reportWebVitals from './reportWebVitals';

import store from './store';

store.dispatch(fetchUser.request());

ReactDOM.render(
  <Provider store={store}>
    <App />
    <Errors />
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
